















import { Component, Vue, Ref } from 'vue-property-decorator'
// D:\font-end\四川建设考前\学员端\frontend_web_customer\src\exam\store\index.ts
import Exam from '@/exam/store/index'
@Component
export default class extends Vue {
  zIndex = 10000
  get showViewer() {
    return this.previewSrcList.length
  }
  get previewSrcList(): Array<string> {
    return Exam.imagePreviewList || new Array<string>()
  }
  @Ref('image') image: any

  doPreview(event: any) {
    if (event.target.tagName === 'IMG') {
      Exam.setPreviewImageList(event.target.src)
      this.image.showViewer = true
    }
  }
  closeViewer() {
    Exam.setPreviewImageList(new Array<any>())
  }
}
